import { getRequest } from '../utils'

export const getHotDimensioningWallPositions: RequestTypeVariable = {
  getKey: (id: string) => ['getHotDimensioningWallPositions', id],
  request: async (projectId): Promise<ExportHotDimensioningWallPositions[] | null> => {
    const { data } = await getRequest<ExportHotDimensioningWallPositions[]>({
      url: `/projects/${projectId}/export/hot-dimensioning-wall-positions`,
    })

    return data
  },
}
